import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Icon } from 'components/ui';
import { colors, radii } from 'style/config';
import { wrapFunctionalComponent } from 'utils/framework';

const CARD_BORDER_WIDTH = 2;

const styles = {
    root: {
        appearance: 'none',
        textAlign: 'left',
        transition: 'border-color 150ms ease',
        ':focus-visible': {
            outline: `2px solid ${colors.black}`,
            outlineOffset: 2
        }
    },
    enabled: {
        cursor: 'pointer',
        background: colors.white
    },
    disabled: {
        cursor: 'default',
        background: colors.lightGray
    }
};

const FulfillmentCard = ({
    id, iconName, title, etaText, etaColor = 'green', secondaryText, disabled, isSelected, onSelect, ariaLabel
}) => {
    const borderColor = disabled ? colors.lightGray : isSelected ? colors.black : colors.lightGray;
    const textColor = disabled ? 'gray' : 'black';
    const secondaryColor = disabled ? 'gray' : etaColor;

    return (
        <Box
            is='button'
            type='button'
            id={id}
            role='radio'
            aria-checked={isSelected}
            aria-disabled={disabled || undefined}
            aria-label={ariaLabel}
            onClick={disabled ? undefined : onSelect}
            paddingX={3}
            paddingY={3}
            borderRadius={radii[1]}
            width='100%'
            height='100%'
            display='flex'
            flexDirection='column'
            justifyContent='flex-start'
            alignItems='flex-start'
            css={[
                styles.root,
                disabled ? styles.disabled : styles.enabled,
                {
                    gap: 4,
                    border: `${CARD_BORDER_WIDTH}px solid ${borderColor}`
                }
            ]}
        >
            <Icon
                name={iconName}
                size={18}
                color={disabled ? 'gray' : undefined}
            />
            <Text
                is='p'
                fontSize='base'
                fontWeight='bold'
                color={textColor}
                lineHeight='tight'
                children={title}
            />
            <Text
                is='p'
                fontSize='sm'
                color={secondaryColor}
                lineHeight='tight'
                children={secondaryText || etaText}
            />
        </Box>
    );
};

FulfillmentCard.propTypes = {
    id: PropTypes.string,
    iconName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    etaText: PropTypes.string,
    etaColor: PropTypes.string,
    secondaryText: PropTypes.string,
    disabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string
};

export default wrapFunctionalComponent(FulfillmentCard, 'FulfillmentCard');
